export default "__VITE_ASSET__Bj4mbUmE__"